import { render } from "./AboutView.vue?vue&type=template&id=5f550002"
import script from "./AboutView.vue?vue&type=script&lang=js"
export * from "./AboutView.vue?vue&type=script&lang=js"
script.render = render

export default script